import './Footer.scss'

import { RootState } from '../../store'
import React from 'react'
import { useSelector } from 'react-redux'

import { FormattedMessage } from 'react-intl'
export const FooterBar = (): React.ReactNode => {
  const userLanguage = useSelector(
    (state: RootState) => state.userLocale.locale
  )

  const url =
    userLanguage == 'fi'
      ? 'https://www.espoo.fi/fi/kaupunki-ja-paatoksenteko/turvallisuus/tietosuoja'
      : 'https://www.espoo.fi/en/city-and-decision-making/safety/data-protection'
  return (
    <footer>
      <a href={url}>
        <FormattedMessage id="data-protection" />
      </a>
    </footer>
  )
}
